import type { ExportSelectProps } from "./types";
import { SimpleSelect } from "./SimpleSelect";

export const ExportSelect = ({
  id,
  label,
  placeholder = "Select one",
  className = "w-72",
  items,
  value,
  onValueChange,
}: ExportSelectProps) => {
  return (
    <SimpleSelect
      id={id}
      label={label}
      placeholder={placeholder}
      triggerClassName={className}
      items={items}
      value={value}
      onValueChange={onValueChange}
    />
  );
};
